export const appconfig = {
    firebase: {
        apiKey: "AIzaSyBJoLkxheH3EoLOuxOyHTdY3fY5h0Xl6Fs",
        authDomain: "ingresopersonal-49e59.firebaseapp.com",
        databaseURL: "https://ingresopersonal-49e59.firebaseio.com",
        projectId: "ingresopersonal-49e59",
        storageBucket: "ingresopersonal-49e59.appspot.com",
        messagingSenderId: "728179023836"
    },
    
    marcar_endpoint: "Marcar",
    infoUsu_endpoint: "InfoUsuarios",
  };
  